<template>
  <div class="auditionList">
    <HearderTitle name="面试列表" />
    <div class="tableBox">
      <div class="tool_bar">
        <el-form :inline="true" :model="queryInfo">
          <el-form-item>
            <el-select v-model="queryInfo.source" clearable>
              <el-option value="前程无忧">前程无忧</el-option>
              <el-option value="智联招聘">智联招聘</el-option>
              <el-option value="58同城">58同城</el-option>
              <el-option value="BOSS直聘">BOSS直聘</el-option>
              <el-option value="QQ群/微信群">QQ微信群</el-option>
              <el-option value="朋友推荐">朋友推荐</el-option>
              <el-option value="拉勾网">拉勾网</el-option>
              <el-option value="其他">其他</el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: -10px">
            <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="search()">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="refTable" header-cell-class-name="h_bg" :data="tableData" style="width: 100%">
          <el-table-column prop="pername" label="姓名" width="80" align="center"> </el-table-column>
          <el-table-column prop="sex" label="性别" align="center"> </el-table-column>
          <el-table-column prop="contact" width="158" label="联系方式" align="center"> </el-table-column>
          <el-table-column prop="gangwei" label="应聘岗位" align="center"> </el-table-column>
          <el-table-column prop="msday" label="毕业时间" align="center"> </el-table-column>
          <el-table-column prop="source" label="信息来源" align="center"> </el-table-column>
          <el-table-column prop="invitePeople" label="邀约人" align="center"> </el-table-column>
          <el-table-column label="是否有简历" align="center">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.isj === 1">
                  <i v-if="!scope.row.pics" @click="showUpload(scope.row)" class="select">上传</i>
                  <i v-else>--</i>
                </span>
                <span v-else>无简历</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="打印简历" align="center">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.isj === 1"> -- </span>
                <span v-else class="select">打印</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ptime" width="200" label="面试时间" align="center"> </el-table-column>
          <el-table-column prop="prepactday" label="转员工" align="center">
            <template slot-scope="scope">
              <div>
                <span class="select" @click="$router.push({ name: 'transferIn', params: { id: scope.row.id, index: scope.$index } })">转入</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="转其他" align="center">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.isp != 5" class="select" @click="show(scope.row.id)">转入其他</span>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="158">
            <template slot-scope="scope">
              <div class="table_btns">
                <el-button size="mini" @click="$router.push({ name: 'auditionDetail', params: { id: scope.row.id } })">查看</el-button>
                <template v-if="scope.row.isp != 5">
                  <el-button @click="$router.push({ name: 'editAudition', params: { id: scope.row.id, index: scope.$index } })" size="mini">编辑</el-button>
                  <el-button size="mini" @click="del(scope.row.id)" class="warning">删除</el-button>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination @current-change="handleCurrentChange" :current-page="queryInfo.pageNum" :page-size="queryInfo.pageSize" layout="total, prev, pager, next,jumper" :total="total" background> </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog class="auditionDialog" ref="auditionDialog" :modal="false" title="转其他类型" destroy-on-close :visible.sync="auditionDialog" width="320px">
      <el-form ref="audition" :rules="rules" :model="auditionData" label-width="90px">
        <el-form-item label="类型" prop="zty">
          <el-select v-model="auditionData.zty" clearable>
            <el-option value="1" label="人才库"></el-option>
            <el-option value="3" label="数据存档"></el-option>
            <!-- <el-option value="4" label="转医护"></el-option> -->
            <el-option value="5" label="黑名单"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="auditionData.zty == 5">
          <el-form-item label="黑名单时效" prop="blacklist_duration">
            <el-select v-model="auditionData.blacklist_duration" clearable>
              <el-option value="0" label="3个月"></el-option>
              <el-option value="1" label="6个月"></el-option>
              <el-option value="2" label="1年"></el-option>
              <el-option value="3" label="2年"></el-option>
              <el-option value="4" label="3年"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="黑名单原因" prop="blacklist_reason">
            <el-input type="textarea" :rows="2" :autosize="{ minRows: 3, maxRows: 6 }" placeholder="请输入内容" v-model="auditionData.blacklist_reason"> </el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <input type="text" v-model="auditionData.id" hidden />
          <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="change()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog class="uploadDialog" destroy-on-close ref="uploadDialog" :modal="false" title="上传图片" :visible.sync="uploadDialog" width="564px" @close="closeUploadDialog">
      <el-form ref="uploadForm" :model="$refs.uploadData">
        <el-form-item>
          <el-upload ref="upload" class="upload-demo" :action="uploadUrl" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :auto-upload="false" :file-list="fileList">
            <input type="text" hidden v-model="uploadData.pics" />
            <input type="text" hidden v-model="uploadData.id" />
            <div slot="tip" class="el-upload__tip">图片上传 (上传完成后会有'上传成功'提示),上传格式:jpg,png,JPG,jpeg,mp4,flv,最大为5M</div>
            <el-button slot="trigger" class="lightBlueBtn" size="small" type="primary">选择文件</el-button>
            <el-button style="margin-left: 10px" size="small" type="danger" @click="$refs.upload.submit()">开始上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button plain @click="uploadSubmit()">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { auditionList, delAudition, editAudition, torencai } from '@/api/audition.js'
  import HearderTitle from '@/components/HearderTitle'
  import pageCacheMix from '@/mixins/pageCacheMix'
  export default {
    name: 'auditionList',
    mixins: [pageCacheMix],
    data() {
      return {
        queryInfo: {
          // 渠道
          source: '',
          invitePeople: '',
          // 当前页
          pageNum: 1,
          // 每页数量
          pageSize: 14,
          isp: 0,
        },
        tableData: [],
        total: 0,
        auditionDialog: false,
        uploadDialog: false,
        fileList: [],
        uploadData: {
          pics: '',
          id: '',
        },
        auditionData: {
          zty: '',
          id: '',
          blacklist_reason: '',
          blacklist_duration: '',
        },
        rules: { zty: [{ required: true, message: '状态不能为空', trigger: 'blur' }] },
      }
    },
    created() {
      this.getAuditionList()
      // 获取上传url
      this.uploadUrl = process.env.VUE_APP_API_URL + '/mypub/loaddail?ty=hr'
    },
    components: { HearderTitle },
    methods: {
      // 获取人员列表
      async getAuditionList() {
        let { plist, statusNum } = await auditionList(this.queryInfo)
        this.tableData = plist.data
        this.total = plist.total
      },
      // 监听当前页码的变化
      handleCurrentChange(newpagenum) {
        this.queryInfo.pageNum = newpagenum
        this.getAuditionList()
      },
      // 搜索
      search() {
        // 页码恢复第一页
        this.queryInfo.pageNum = 1
        this.getAuditionList()
      },
      // 删除人员
      async del(id) {
        if (!id) return this.$message.error('请选择要删除的数据')
        const res = await this.$confirm('您确定删除该用户吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).catch((err) => err)
        if (res !== 'confirm') return this.$message.info('取消成功')
        let response = await delAudition({ id })
        if (response.status !== 200) {
          this.$message.error('删除失败')
        } else {
          this.$message.success('删除成功')
          // 删除成功后刷新页面
          this.getAuditionList()
        }
      },
      // 显示修改状态弹窗
      show(id) {
        this.auditionData.id = id
        this.auditionDialog = true
      },
      showUpload(data) {
        this.uploadData.id = data.id
        this.uploadDialog = true
      },
      closeUploadDialog() {
        this.uploadData.pics = ''
      },
      async change() {
        this.$refs['audition'].validate(async (valid) => {
          if (!valid) return
          if (this.auditionData.id !== '') {
            let data = this.auditionData
            let res = await torencai(data)
            if (res.status !== 200) return this.$message.error('提交失败')
            this.$message.success('提交成功')
            this.$refs['audition'].resetFields()
            this.auditionDialog = false
            return this.getAuditionList()
          } else {
            return this.$message.error('id不能为空')
          }
        })
      },
      // 上传图片
      handleAvatarSuccess(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        let len = this.uploadData.pics.length
        if (len === 0) {
          this.uploadData.pics += 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        } else {
          this.uploadData.pics += ',http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        }
      },
      // 上传限制
      beforeAvatarUpload(file) {
        const isJPG = ['image/jpeg', 'image/png']
        const isLt5M = file.size / 1024 / 1024 < 6
        if (!isJPG.includes(file.type)) {
          this.$message.error('上传头像图片只能是JPG或PNG 格式!')
        }
        if (!isLt5M) {
          this.$message.error('上传头像图片大小不能超过 5MB!')
        }
        return isJPG.includes(file.type) && isLt5M
      },
      async uploadSubmit() {
        if (!this.uploadData.pics) return this.$message.error('上传图片不能为空')
        let res = await editAudition(this.uploadData)
        if (res.status !== 200) return this.$message.error('提交失败')
        this.$message.success('提交成功')
        return this.getAuditionList()
      },
    },

    // 局部更新编辑后数据
    activated() {
      let editData = sessionStorage.getItem('editData') || null
      let editDataIndex = sessionStorage.getItem('editDataIndex') || ''
      if (editData && editDataIndex !== '') {
        editData = JSON.parse(editData)
        // 更新修改数据
        this.$set(this.tableData, editDataIndex, editData)
        //删除缓存数据
        sessionStorage.removeItem('editDataIndex')
        sessionStorage.removeItem('editData')
      } else {
        //删除缓存数据
        sessionStorage.removeItem('editDataIndex')
        sessionStorage.removeItem('editData')
        return
      }
    },
  }
</script>

<style lang="less">
  .auditionList {
    .tableBox {
      .select {
        color: #015293;
        font-size: 12px;
        cursor: pointer;
      }
      .tool_bar {
        padding-top: 28px;
        padding-bottom: 18px;
        font-size: 14px;
        color: #888;
        .el-form-item {
          margin-right: 20px;
          margin-bottom: 0;
          .el-input__inner {
            width: 210px;
            height: 32px;
          }
          .el-input__inner {
            padding-left: 10px;
          }
          .middle {
            padding: 0 10px;
          }
          .searchBtn {
            width: 82px;
          }
        }
      }
      .el-table {
        min-height: 685px;
        &::before {
          height: 0;
        }
      }
    }
  }
  .auditionDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-dialog__body {
      padding-bottom: 0;
      overflow: hidden;
      .el-form-item {
        margin-bottom: 15px;
      }
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner,
    .el-textarea__inner {
      width: 178px;
    }
    .el-input__inner {
      padding-left: 15px;
      width: 178px;
    }
    .searchBtn {
      width: 112px;
    }
  }
  .uploadDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-form {
      .el-form-item {
        &:last-child {
          margin-bottom: 0;
          .el-button {
            float: right;
            width: 112px;
            height: 32px;
            padding: 0;
            text-align: center;
          }
        }
      }
    }
  }
</style>
